export interface Price {
  priceId: string;
  name: string;
  country: PriceCountry;
  privacyStatus: string;
  tariffModel: string;
  direction: string;
  sunday: string;
  currency: string;
  hasTwoPrices: boolean;
  pricingList: Pricing[];
  tax: number;
  lastModify: string;
  type: PriceType;
  blockList: Block[];
}

export interface Pricing {
  dateFrom: string;
  dateTo: string;
  timeSlots: TimeSlot[];
}

export interface TimeSlot {
  timeFrom: string;
  timeTo: string;
  priceKWH: number;
  priceDistribution: number;
  priceTransfer: number;
  priceOIE: number;
  pricePerPeakPower: number;
}

interface Block {
  range: string;
  priceKWH_H: number;
  priceDistribution_H: number;
  priceTransfer_H: number;
  priceKWH_L: number;
  priceDistribution_L: number;
  priceTransfer_L: number;
  priceOIE: number;
}

export enum PriceLabel {
  HOME_ONETIME_ANALYSIS_COST = 'HOME_ONETIME_ANALYSIS_COST',
  BUSINESS_ONETIME_ANALYSIS_COST = 'BUSINESS_ONETIME_ANALYSIS_COST',
  BUSINESS_SUBSCRIPTION_PACKET_COST = 'BUSINESS_SUBSCRIPTION_PACKET_COST',
  BUSINESS_PLUS_SUBSCRIPTION_PACKET_COST = 'BUSINESS_PLUS_SUBSCRIPTION_PACKET_COST'
}

export enum PriceType {
  HOME = 'HOME',
  ENTERPRISE = 'ENTERPRISE',
}

export enum PriceCountry {
  HR = 'HR',
  BA_RS = 'BA_RS',
  BA_FE = 'BA_FE',
}

export enum Currency {
  EUR = 'EUR',
  BAM = 'BAM',
}

export enum PriceDirection {
  BUY = 'buy',
  SELL = 'sell',
}

export const currencyFromCountry = (country: PriceCountry): Currency => {
  switch (country) {
    case PriceCountry.BA_FE:
    case PriceCountry.BA_RS:
      return Currency.BAM;
    case PriceCountry.HR:
      return Currency.EUR;
    default:
      return Currency.EUR;
  }
};
